import React, { useContext, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { GlobalContext } from '../../../providers/GlobalProvider';
import { CircularProgress } from '@mui/material';
import ContactAPI from 'api/ContactAPI';

interface IAddBrokerModalProps {
  open: boolean;
  handleClose: () => void;
  handleSave: any;
}

export const AddBrokerModal: React.FC<IAddBrokerModalProps> = ({
  open,
  handleClose,
  handleSave,
}) => {
  const { cur_user } = useContext(GlobalContext);

  // Product fields
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [contactType, setContactType] = useState<string>('');
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const handleContactAddition = async () => {
    setIsSaving(true);
    try {
      const newBroker = {
        name: name,
        email: email,
        contact_type: contactType,
        group_id: cur_user?.selected_team?.id,
      };

      // Use the createProduct endpoint
      await ContactAPI.createContact(newBroker);
      enqueueSnackbar('Contact added successfully', { variant: 'success' });
      handleSave();
      setIsSaving(false);
      handleClose();
    } catch (err) {
      enqueueSnackbar('Error adding contact', { variant: 'error' });
      console.error('Error adding contact:', err);
    }
  };

  return (
    <>
      <Dialog
        className='dialog_box'
        open={open}
        onClose={handleClose}
        maxWidth='md'
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: 'var(--bg-colors)',
            boxShadow:
              '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            borderRadius: '0.5rem',
            overflowY: 'visible',
            maxWidth: '800px',
            width: '90%',
            margin: '0 auto',
          },
        }}
      >
        <DialogTitle
          id='product-modal-title'
          className='modal-header-content modal-title'
        >
          Add Contact
          <div
            className='audit-add-modal-head-cont-icon'
            onClick={handleClose}
            style={{ cursor: 'pointer' }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
            >
              <path
                d='M1.5 1.5L16.5 16.5M16.5 1.5L1.5 16.5'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
        </DialogTitle>
        <DialogContent className='dialog-content-base'>
          <div
            className='audit-add-modal-cont-body'
            style={{ paddingTop: '12px', paddingBottom: '12px' }}
          >
            <div className='audit-add-modal-cont-body-frame'>
              <div className='audit-add-modal-cont-body-frame-form'>
                <div className='audit-add-modal-cont-body-frame-form-row'>
                  <div className='grid-layout' style={{ width: '100%' }}>
                    <div>
                      <label
                        htmlFor='name'
                        className='audit-add-modal-cont-body-frame-form-row-input-label-text'
                      >
                        Name <span className='required-star'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder='Name'
                        className='audit-add-modal-cont-body-frame-form-input'
                        style={{ width: '100%' }}
                      />
                    </div>
                    {/* Email */}
                    <div>
                      <label
                        htmlFor='email'
                        className='audit-add-modal-cont-body-frame-form-row-input-label-text'
                      >
                        Email <span className='required-star'>*</span>
                      </label>
                      <input
                        type='text'
                        id='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder='Email'
                        className='audit-add-modal-cont-body-frame-form-input'
                        style={{ width: '100%' }}
                      />
                    </div>
                    {/* Category */}
                    <div>
                      <label
                        htmlFor='contactType'
                        className='audit-add-modal-cont-body-frame-form-row-input-label-text'
                      >
                        Contact Type <span className='required-star'>*</span>
                      </label>
                      <select
                        id='contactType'
                        className='audit-add-modal-cont-body-frame-form-input'
                        style={{ width: '100%' }}
                        value={contactType}
                        onChange={(e) => setContactType(e.target.value)}
                      >
                        <option value=''>Select contact type</option>
                        <option value='customs_broker'>Customs Broker</option>
                        <option value='erp_system'>ERP System</option>
                        <option value='third_party_provider'>
                          Third-Party Provider
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='audit-modal-cont-footer'>
                <div className='audit-modal-cont-footer-content'>
                  <div
                    className='audit-modal-cont-footer-content-btn-cancel'
                    onClick={handleClose}
                  >
                    <div className='audit-modal-cont-footer-content-btn-text'>
                      Cancel
                    </div>
                  </div>
                  <div
                    className='audit-modal-cont-footer-content-btn-upload'
                    onClick={!isSaving ? handleContactAddition : undefined}
                  >
                    <div
                      className={`audit-modal-cont-footer-content-btn-text ${
                        isSaving ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                      style={{ color: '#FFF' }}
                    >
                      {isSaving ? (
                        <span className='flex items-center justify-center'>
                          <CircularProgress
                            style={{
                              color: '#FFF',
                              marginTop: '5px',
                              width: '30px',
                              height: '30px',
                            }}
                          />
                          Saving...
                        </span>
                      ) : (
                        'Save'
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
